<style lang="scss">
    .main-box{
        background: #ffffff;
        width: 1150px;
        height: 523px;
        margin: 0 auto;
    }
    .page-title {
        padding: 20px 40px 5px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;
            float:left;
            line-height:55px;

        }
        .guangfa{
            width:166px;
            float:left;
            text-align:center;
            img{width:383px;height:50px;}
            span{
                font-size:12px;
                color:#c2c4ca;
            }
        }
        .payCenter{
            float: left;
            width: 166px;
            text-align: center;
            font-family: microsoft yahei;
            color: #333333;
            font-size: 24px;
            line-height: 50px;
        }
    }
    .page-title-buttom{
        border-top:1px #d8d9df solid ;
        height:70px;
        p{
            color:#333333;
            font-size:14px;
            padding-left:36px;
            line-height:70px;
        }
    }
    .guide-box{
        .pic-guide{
            text-align: center;
        }
        .success-wrap,.error-wrap{
            height:340px; 
            display: -webkit-flex;
            align-items: center;  
            justify-content: center;
            .con-wrap{
                width:700px;
                margin:0 auto;
                img{
                    width: 103px;
                    height: 78px;
                    float: left;
                }
                .success-wrap-con,.error-wrap-con{
                    margin-left:19px;
                    text-align: left;
                    float: left;
                    h2{
                        color:#48D2A0 ;
                        font-size:24px;
                        font-weight: normal;
                        margin-bottom: 10px;
                    }
                    p{
                        font-size:16px;
                        color:#666666;
                    }
                    
                }
                .error-wrap-con{
                    padding-top:10px;
                }
                .error-wrap-con h2{
                    color:#666666;
                    font-size:24px;
                }
            }
            
            
        }
        router-link{
            color: #ffb97b;
        }
        .res-button{
            background:#57A0FF;
            border-radius: 4px;
            border-radius: 4px;
            color:white; 
            font-size:16px;
            width:282px;
            height:44px;
            margin-top:63px;   
        }
        
    }
</style>


<template>
   <div class="main-box">
       <div class="main-wrap">
            <div class="page-title clearfix">
                <div class="guangfa"><img src="../../assets/result/testDen.png" alt=""></div>
            </div>
            <div class="guide-box">
                <div class="pic-guide clearfix">
                    <div class="success-wrap"  v-if="$route.query.state == '02'">
                        <div class="con-wrap clearfix">
                            <img src="../../assets/result/success.png" alt="">
                            <div class="success-wrap-con">
                                <h2>广发银行交易信息验证成功！</h2>
                                <p>请您至<router-link>宜人贷官网-存管信息</router-link>提示页，点击“<route-link>已完成验证</route-link>”按钮继续完成操作</p>
                            </div>
                        </div>
                    </div>
                    <div class="error-wrap"  v-else>
                        <div class="con-wrap clearfix">
                            <img src="../../assets/result/error.png" alt="">
                            <div class="error-wrap-con">
                                <h2>广发银行交易信息验证失败。</h2>
                                <el-button class="res-button">重新验证</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-title-buttom clearfix">
                <p>温馨提示：请您至宜人贷官网继续完成操作，当前页面不能进行操作。</p>
            </div>
        </div>
   </div>
</template>
<script>

	export default {
		data(){
			return {}
        },
	}
</script>